/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import { StatusCode } from './constants';

/* eslint-disable max-len */
export const ERROR_CODE_MESSAGES = {
  SOCIAL_VERIFIER_ACCOUNT_ALREADY_LINKED: 'linkedAccounts:errors:alreadyLinked',
  SOCIAL_VERIFIER_ACCOUNT_ALREADY_CLAIMED: 'linkedAccounts:errors:alreadyClaimed',
  LINK_INIT_FAILED_ERROR: 'linkedAccounts:errors:linkInitFailed',
  WRONG_REQUEST_FORMAT: 'general:errors:WRONG_REQUEST_FORMAT',
  SOCIAL_PROVIDER_ERROR: 'general:errors:commonNotification',
  SOCIAL_PROVIDER_NOT_SUPPORTED: 'general:errors:commonNotification',
  SOCIAL_VERIFIER_ERROR: 'general:errors:commonNotification',
  USER_UNAUTHORIZED: 'general:errors:USER_UNAUTHORIZED',
  GENERAL_ERROR: 'general:errors:commonError',
  DEFAULT_LOGOUT_ERROR_MESSAGE: 'linkedAccounts:errors:logoutFailed',
  DEFAULT_SOCIAL_AUTH_ERROR_MESSAGE: 'linkedAccounts:errors:socialAuthFailed',
  UNAUTHORIZED: 'general:errors:sessionExpired',
  SOCIAL_VERIFIER_SAME_ACCOUNT_ALREADY_LINKED: 'linkedAccounts:errors:generalError',
  AGE_ELIGIBILITY_ERROR: 'linkedAccounts:errors:generalError'
};

export const ERROR_STATUS_MESSAGES = {
  [StatusCode.Unauthorized]: 'general:errors:sessionExpired'
};

export const DEFAULT_NOT_FOUND_MESSAGE_CODE = 'general:notFound:mainMessage';
export const DEFAULT_SOCIAL_LINK_NOTIFICATION = 'general:errors:commonNotification';
